import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-quote-loading',
  templateUrl: './quote-loading.component.html',
  styleUrls: ['./quote-loading.component.css']
})
export class QuoteLoadingComponent implements OnInit {
  
  @Input() loadingMessage: string = 'Cargando cotización...';
  @Input() loadingSubMessage: string = 'Por favor espere mientras procesamos su solicitud';
  @Input() showSpinner: boolean = true;
  
  constructor() { 
    console.log('QuoteLoadingComponent constructor called');
  }
  
  ngOnInit() {
    console.log('QuoteLoadingComponent ngOnInit - loadingMessage:', this.loadingMessage);
  }
}
